module.exports = __webpack_public_path__ + "static/media/trip_key_6.02f92447.png";